// Cabin
// Features:
// - Root component for the cabin structure
// - Loads shared GLTF geometry and base texture

import { useMemo } from 'react'
import { useTexture, useGLTF } from '@react-three/drei'
import * as THREE from 'three'

import { PHASES } from '../../store/usePhase'

import CabinInside from './CabinInside'
import CabinOutside from './CabinOutside'
import LightPlane from './LightPlane'
import WhenPhase from '../WhenPhase'

import cabinTextureURL from '/textures/cabin.webp'

export default function Cabin() {
    // Geometry
    const { nodes } = useGLTF('/models/cabin_full.glb')

    // Textures
    const cabinTexture = useTexture(cabinTextureURL, (texture) => {
        texture.colorSpace = THREE.SRGBColorSpace
        texture.flipY = false
    })

    // Shared Physics Material (Invisible)
    const physicsMaterial = useMemo(
        () => new THREE.MeshBasicMaterial({ visible: false }),
        []
    )

    return (
        <group>
            {/* Cabin Parts */}
            <CabinInside
                nodes={nodes}
                cabinTexture={cabinTexture}
                physicsMaterial={physicsMaterial}
            />
            <CabinOutside
                nodes={nodes}
                cabinTexture={cabinTexture}
                physicsMaterial={physicsMaterial}
            />

            {/* External Effects */}
            <WhenPhase excludes={[PHASES.inCabin]}>
                <LightPlane nodes={nodes} />
            </WhenPhase>
        </group>
    )
}
